
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog, useMetadataCatalog } from "@/store";
import { defineComponent } from "@vue/composition-api";
import { zipObject } from "lodash";
import { mapState } from "pinia";
import config from "@/util/constants";

export default defineComponent({
  name: "AddUpdateCat",
  data: () => ({
    updateMethodTbl: new Array<any>(),
    timeTbl: new Array<any>(),
    teamTbl: new Array<any>(),

    dpRequest: {} as IDataProviderRequest,
    fields: new Array<string>(),
    items: new Array<any>(),

    // updateMethodTblN: "update_method",
    // timeTblN: "time",
    // teamTblN: "team",
    // tblPath: "/data_mgmt/all/System/",

    updateMethodTblN: config.metaCat.v_update_method,
    timeTblN: config.metaCat.v_time,
    teamTblN: config.metaCat.v_team,
    tblPath: "/meta_cat/",

    dataCatEntry: {
      data_cat_id: { val: null, type: Number, isRequired: true },
      update_method_id: { val: null, type: Number, isRequired: true },
      update_freq_time_id: { val: null, type: Number, isRequired: true },
      update_freq: { val: null as any, type: Number, isRequired: true },
      change_freq_time_id: { val: null, type: Number, isRequired: true },
      change_freq: { val: null as any, type: Number, isRequired: true },
      change_freq_desc: { val: null, type: Number, isRequired: false },
      update_team_id: { val: null, type: Number, isRequired: true },
      last_update_due_date: { val: null, type: String, isRequired: true },
      next_update_due_date: { val: null, type: String, isRequired: true },
      update_effort_points: {
        val: null as any,
        type: Number,
        isRequired: true,
      },
    },
  }),
  computed: {
    ...mapState(useCatalog, ["tableMeta", "tableData"]),
    ...mapState(useMetadataCatalog, ["updateCatUri", "selectedDataCatId"]),
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.dataCatEntry.data_cat_id.val = this.selectedDataCatId;
      await this.catalogChange(this.updateMethodTblN);
      await this.catalogChange(this.timeTblN);
      await this.catalogChange(this.teamTblN);
    },
    async loadData(tableName: string, columns: Array<string>) {
      await useCatalog()
        .getTableData({
          catalogUri: this.tblPath + tableName,
          request: this.dpRequest,
        })
        .then(() => this.setTableData(tableName, columns));
    },
    setTableData(tableName: string, columns: Array<string>) {
      if (this.tableData?.rows.length) {
        switch (tableName) {
          case this.updateMethodTblN:
            this.updateMethodTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.timeTblN:
            this.timeTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.teamTblN:
            this.teamTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          default:
            this.showMessage(
              "danger",
              "Couldn't find the matching table name!! - " + tableName
            );
            break;
        }
      }
    },
    async catalogChange(tableName: string) {
      // Retrieve table meta
      await useCatalog()
        .getTableMeta({
          catalogUri: this.tblPath + tableName,
          request: {},
        })
        .then(() => {
          this.setTableColumns(tableName);
        });
    },
    setTableColumns(tableName: string) {
      if (this.tableMeta?.columns.length) {
        let columns = this.tableMeta.columns.map(
          (c: { columnName: string }) => c.columnName
        );
        this.loadData(tableName, columns);
      }
    },
    getValidVal(col: any) {
      if (col !== null && col !== "") {
        return Number(col);
      } else return null;
    },
    async updateDB(param: string) {
      this.dataCatEntry.update_freq.val = this.getValidVal(
        this.dataCatEntry.update_freq.val
      );
      this.dataCatEntry.change_freq.val = this.getValidVal(
        this.dataCatEntry.change_freq.val
      );
      this.dataCatEntry.update_effort_points.val = this.getValidVal(
        this.dataCatEntry.update_effort_points.val
      );
      const methodN = "updateDB";
      const requestFrom = "update_cat";
      const nextPage = "update_log";
      const catUri = "";

      this.$emit(
        methodN,
        requestFrom,
        param,
        this.dataCatEntry,
        nextPage,
        catUri,
        this.updateCatUri
      );
    },
    showMessage(type: string, msg: string) {
      this.$root.$emit("showAlert", 4, type, msg);
    },
  },
});
